export default __webpack_public_path__ + "images/Clean_Clear_Logo.png";